import * as React from 'react';

export const pyFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_374)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_374'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_374)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 13.3333H28V20H0V13.3333Z'
                    fill='#0035A9'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M15.96 9.59999C15.9867 9.72932 16 9.86266 16 9.99999C16 11.104 15.104 12 14 12C12.896 12 12 11.104 12 9.99999C12 9.86266 12.0133 9.72932 12.04 9.59999C12.2267 10.208 13.032 10.6667 14 10.6667C14.968 10.6667 15.7733 10.208 15.96 9.59999Z'
                    fill='#018430'
                />
                <path
                    d='M14 9.33333C14.3682 9.33333 14.6666 9.03486 14.6666 8.66667C14.6666 8.29848 14.3682 8 14 8C13.6318 8 13.3333 8.29848 13.3333 8.66667C13.3333 9.03486 13.6318 9.33333 14 9.33333Z'
                    fill='#FFDA2C'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0H28V6.66667H0V0Z'
                    fill='#D62718'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_374'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
